import Style from "./css/style.module.css";

function FrontCoverArea(props: any) {
  let myProps = {
    info: {},
    ...props
  };
  let info = myProps.info;
  let front_cover_main_img_src = process.env.REACT_APP_API_URL + "/img/comp/edu/comp_stu_prescribe/front_cover_main_img.png";
  let front_cover_icon_src= process.env.REACT_APP_API_URL + "/img/comp/edu/comp_stu_prescribe/prescribe_logo350.png";
  let front_cover_line1_src= process.env.REACT_APP_API_URL + "/img/comp/edu/comp_stu_prescribe/front_cover_line1.png";
  let front_cover_line2_src= process.env.REACT_APP_API_URL + "/img/comp/edu/comp_stu_prescribe/front_cover_line2.png";

  return (
    <div className={"a4subpage " + Style.front_cover_wrap} >
      <div className={Style.front_cover_con}>
        <div className={Style.top_area}>
          <div className={Style.top_title}>
            학습처방
          </div>
          <div className={Style.top_title}>
            입학테스트
          </div>
          <div className={Style.top_title + " " + Style.top_title_gray}>
            분석표
          </div>
          <div className={Style.top_sub_title_wrap}>
            <div className={Style.top_sub_title}>
              “이 보고서의 목적은 현재의 수준 평가가 아닙니다.
            </div>
            <div className={Style.top_sub_title}>
              학생에게 맞는 성장 설계를 위한 출발점입니다.”
            </div>
          </div>
          <div className={Style.top_center_img_wrap}>
            <img src={front_cover_main_img_src} />
          </div>
        </div>
        <div className={Style.bottom_area}>
          <div className={Style.bottom_left}>
            <div className={Style.bottom_left_line_wrap}>
              <img src={front_cover_line1_src} />
            </div>
            <div>
              <table className={Style.info_table}>
                <colgroup>
                  <col width={"110px"}></col>
                  <col width={"*"}></col>
                </colgroup>
                <tbody>
                  <tr>
                    <th>학생명:</th>
                    <td>{info.a_stu_name}</td>
                  </tr>
                  <tr>
                    <th>학<span className="ml-7"></span>년:</th>
                    <td>{info.a_stu_grade_str}</td>
                  </tr>
                  <tr>
                    <td colSpan={2}>검사내용</td>
                  </tr>
                  <tr>
                    <td colSpan={2} className={Style.check_content} >
                      {info.a_check_content}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className={Style.bottom_left_line_wrap}>
              <img src={front_cover_line2_src} />
            </div>
          </div>
          <div className={Style.bottom_right}>
            <span className={Style.logo_img_wrap}>
              <img src={front_cover_icon_src} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FrontCoverArea;